module.exports = __webpack_public_path__ + "static/img/camerafor.d2cc5db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/camerafor.png
// module id = 2XMU
// module chunks = 24